import {
  CONFIRMED_GET_LEADS,
  CONFIRMED_CREATE_LEAD_ACTION,
  CONFIRMED_DELETE_LEAD_ACTION,
  CONFIRMED_EDIT_LEAD_ACTION,
  CONFIRMED_ADD_LEAD_MARRIAGE_INFO,
  CONFIRMED_ADD_LEAD_ADDRESS_INFO,
  CONFIRMED_ADD_LEAD_OTHER_INFO,
  CONFIRMED_GET_LEAD_DETAILS,
  CONFIRMED_GET_TELECALLER_LIST,
  ASSIGN_LEADS_REQUEST,
  ASSIGN_LEADS_SUCCESS,
  ASSIGN_LEADS_FAILURE,
  ADD_APPOINTMENT_TO_LEAD,
  UPDATE_APPOINTMENT_IN_LEAD,
  REMOVE_APPOINTMENT_FROM_LEAD,
} from "../actions/LeadType";

const initialState = {
  leadDetails: null,
  leads: [],
  num_rows: 0,
  marriageInfo: null,
  addressInfo: null,
  otherInfo: null,
  telecallers: [],
  assigning: false,
  assignSuccess: false,
  assignError: null,
  loading: false,
  error: null,
};

export default function LeadReducers(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_LEADS:
      return {
        ...state,
        // leads: action.payload,
        leads: action.payload.leads || action.payload,
        num_rows: action.payload.num_rows || 0,
        loading: false,
        error: null,
      };

    case CONFIRMED_GET_LEAD_DETAILS:
      return {
        ...state,
        leadDetails: action.payload,
      };

    case CONFIRMED_CREATE_LEAD_ACTION:
      return {
        ...state,
        leads: [...state.leads, action.payload],
      };

    case CONFIRMED_ADD_LEAD_MARRIAGE_INFO: {
      const leads = [...state.leads];
      const index = leads.findIndex(
        (l) => l.lead_id === action.payload.lead_id
      );
      if (index !== -1) {
        leads[index] = {
          ...leads[index],
          marriageInfo: action.payload,
        };
      }
      return { ...state, leads };
    }

    case CONFIRMED_ADD_LEAD_ADDRESS_INFO: {
      const leads = [...state.leads];
      const index = leads.findIndex(
        (l) => l.lead_id === action.payload.lead_id
      );
      if (index !== -1) {
        leads[index] = {
          ...leads[index],
          addressInfo: action.payload,
        };
      }
      return { ...state, leads };
    }

    case CONFIRMED_ADD_LEAD_OTHER_INFO: {
      const leads = [...state.leads];
      const index = leads.findIndex(
        (l) => l.lead_id === action.payload.lead_id
      );
      if (index !== -1) {
        leads[index] = {
          ...leads[index],
          otherInfo: action.payload,
        };
      }
      return { ...state, leads };
    }

    case CONFIRMED_EDIT_LEAD_ACTION: {
      const updatedLeadId = action.payload.lead_id;
      if (!updatedLeadId) {
        console.warn("No lead_id found in CONFIRMED_EDIT_LEAD_ACTION payload");
        return state;
      }
      const updatedLeads = state.leads.map((lead) =>
        lead.lead_id === updatedLeadId ? action.payload : lead
      );
      return {
        ...state,
        leads: updatedLeads,
      };
    }

    case CONFIRMED_DELETE_LEAD_ACTION:
      return {
        ...state,
        leads: state.leads.filter(
          (lead) => lead.lead_id !== action.payload.lead_id
        ),
      };

    case CONFIRMED_GET_TELECALLER_LIST:
      return {
        ...state,
        telecallers: action.payload,
        loading: false,
      };

    case ASSIGN_LEADS_REQUEST:
      return {
        ...state,
        assigning: true,
        assignSuccess: false,
        assignError: null,
      };

    case ASSIGN_LEADS_SUCCESS:
      return {
        ...state,
        assigning: false,
        assignSuccess: true,
        assignError: null,
      };

    case ASSIGN_LEADS_FAILURE:
      return {
        ...state,
        assigning: false,
        assignSuccess: false,
        assignError: action.payload,
      };

    case ADD_APPOINTMENT_TO_LEAD: {
      if (!state.leadDetails) return state;

      const updatedLeadDetails = { ...state.leadDetails };

      // Handle both possible structures
      if (updatedLeadDetails.data?.AppointmentDetails) {
        updatedLeadDetails.data.AppointmentDetails = [
          ...updatedLeadDetails.data.AppointmentDetails,
          action.payload,
        ];
      } else if (updatedLeadDetails.AppointmentDetails) {
        updatedLeadDetails.AppointmentDetails = [
          ...updatedLeadDetails.AppointmentDetails,
          action.payload,
        ];
      } else {
        // Initialize AppointmentDetails if it doesn't exist
        if (updatedLeadDetails.data) {
          updatedLeadDetails.data.AppointmentDetails = [action.payload];
        } else {
          updatedLeadDetails.AppointmentDetails = [action.payload];
        }
      }

      return {
        ...state,
        leadDetails: updatedLeadDetails,
      };
    }

    case UPDATE_APPOINTMENT_IN_LEAD: {
      if (!state.leadDetails) return state;

      const updatedLeadDetails = { ...state.leadDetails };

      // Handle both possible structures
      if (updatedLeadDetails.data?.AppointmentDetails) {
        updatedLeadDetails.data.AppointmentDetails =
          updatedLeadDetails.data.AppointmentDetails.map((appointment) =>
            appointment.appointment_id === action.payload.appointment_id
              ? { ...appointment, ...action.payload }
              : appointment
          );
      } else if (updatedLeadDetails.AppointmentDetails) {
        updatedLeadDetails.AppointmentDetails =
          updatedLeadDetails.AppointmentDetails.map((appointment) =>
            appointment.appointment_id === action.payload.appointment_id
              ? { ...appointment, ...action.payload }
              : appointment
          );
      }

      return {
        ...state,
        leadDetails: updatedLeadDetails,
      };
    }

    case REMOVE_APPOINTMENT_FROM_LEAD: {
      if (!state.leadDetails) return state;

      const updatedLeadDetails = { ...state.leadDetails };

      // Handle both possible structures
      if (updatedLeadDetails.data?.AppointmentDetails) {
        updatedLeadDetails.data.AppointmentDetails =
          updatedLeadDetails.data.AppointmentDetails.filter(
            (appointment) =>
              appointment.appointment_id !== action.payload.appointment_id
          );
      } else if (updatedLeadDetails.AppointmentDetails) {
        updatedLeadDetails.AppointmentDetails =
          updatedLeadDetails.AppointmentDetails.filter(
            (appointment) =>
              appointment.appointment_id !== action.payload.appointment_id
          );
      }

      return {
        ...state,
        leadDetails: updatedLeadDetails,
      };
    }

    default:
      return state;
  }
}
